module.exports = __webpack_public_path__ + "img/flecha-boton.68de9036.svg";